import { cn } from "@/lib/utils";

/**
 * Crédito do site: "© Copyright 2026 • Desenvolvido por OTL Tecnologia".
 *
 * Um componente só para a loja, as áreas logadas e as telas de entrar — o
 * texto é o mesmo em todo lugar, e o ano vem do relógio (não envelhece).
 */
export function SiteCredit({ className }: { className?: string }) {
  return (
    <p className={cn("text-center text-[11px] leading-4 text-mb-muted", className)}>
      © Copyright {new Date().getFullYear()} • Desenvolvido por{" "}
      <a
        href="https://www.otltecnologia.com.br"
        target="_blank"
        rel="noopener noreferrer"
        className="font-semibold underline-offset-2 hover:text-mb-navy hover:underline"
      >
        OTL Tecnologia
      </a>{" "}
      (www.otltecnologia.com.br)
    </p>
  );
}

/** Rodapé com o crédito, para o fim das páginas. */
export function SiteFooter({ className }: { className?: string }) {
  return (
    <footer className={cn("border-t border-mb-line px-4 py-5", className)}>
      <SiteCredit />
    </footer>
  );
}
